import { ArrowShortDownIcon, ArrowShortUpIcon } from '@fourthwall/icons'
import React, { useState } from 'react'

import { ColorItem } from '../../common/ColorItem'
import { ColorPicker } from '../../common/ColorPicker'
import { Icon } from '../../common/Icon'
import { Popper } from '../../common/Popper'
import { withFormikSupport } from '../../hocs/withFormikSupport'
import { Checkboard } from '../../partials/Checkboard'
import { useMediaQueryContext } from '../../providers/MediaQueryProvider'
import { InputUI } from '../../ui'
import * as S from './styled'
import type { ColorInputProps } from './types'

const ColorInputComponent = ({
  label = 'Color',
  value,
  hexVisible = true,
  size = 'large',
  onChange,
  onBlur,
  onOpen,
  onClose,
}: ColorInputProps) => {
  const media = useMediaQueryContext()
  const [isOpen, setOpen] = useState(false)

  const toggleOpen = () => {
    setOpen((prevIsOpen) => {
      if (!prevIsOpen && onOpen) {
        onOpen()
      }
      if (prevIsOpen && onClose) {
        onClose()
      }

      return !prevIsOpen
    })
  }

  const handleChange = (color: string) => {
    if (onChange) {
      onChange(color)
    }

    if (onBlur) {
      onBlur(color)
    }
  }

  return (
    <Popper
      isOpen={isOpen}
      referenceComponent={
        <S.InputContainer onClick={toggleOpen} aria-label={label}>
          <InputUI.Box $size={size} $focused={isOpen}>
            <S.ColorContainer>
              <Checkboard />
              {value && (
                <S.ColorItemContainer>
                  <ColorItem appearance="multi-select" color={{ label: '', value }} />
                </S.ColorItemContainer>
              )}
            </S.ColorContainer>
            <S.ChevronContainer>
              {isOpen && <Icon component={ArrowShortUpIcon} height={12} />}
              {!isOpen && <Icon component={ArrowShortDownIcon} height={12} />}
            </S.ChevronContainer>
          </InputUI.Box>
        </S.InputContainer>
      }
      popperProps={{
        placement: 'bottom-start',
      }}
      style={media.tablet ? { paddingTop: 12, paddingBottom: 12 } : undefined}
      onClose={() => setOpen(false)}
    >
      <ColorPicker
        color={value}
        position="bottom-start"
        format="HEX"
        hexVisible={hexVisible}
        onValueChange={handleChange}
      />
    </Popper>
  )
}

export const ColorInput = withFormikSupport(ColorInputComponent)
